export default __webpack_public_path__ + "static/media/right_answer.e977502f.mp3";